import { render } from "./MenuSubTrigger.vue?vue&type=template&id=2d8e89e1&ts=true"
import script from "./MenuSubTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSubTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuSubTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d8e89e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d8e89e1', __exports__)) {
    api.reload('2d8e89e1', __exports__)
  }
  
  module.hot.accept("./MenuSubTrigger.vue?vue&type=template&id=2d8e89e1&ts=true", () => {
    api.rerender('2d8e89e1', render)
  })

}


export default __exports__